"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var instantDiscountApi = _interopRequireWildcard(require("@/api/instantDiscountApi.js"));
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateTimeRange = function validateTimeRange(rule, value, callback) {
      // 仅当 status 为 2（指定时间段有效）时才校验时间范围
      if (_this.formData.status !== 2) {
        callback();
        return;
      }
      var startTime = _this.formData.startTime;
      var endTime = _this.formData.endTime;
      if (!startTime || !endTime) {
        callback();
        return;
      }
      if (new Date(startTime) > new Date(endTime)) {
        callback(new Error('活动开始时间不能大于活动结束时间'));
      } else {
        callback();
      }
    };
    var validateThreshold = function validateThreshold(rule, value, callback) {
      if (value === null || value === undefined) {
        callback(new Error('请输入活动门槛'));
      } else if (value < 0) {
        callback(new Error('门槛不能为负数'));
      } else if (value > 999999999) {
        callback(new Error('门槛不能超过999999999'));
      } else {
        callback();
      }
    };
    var validateDiscountList = function validateDiscountList(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error('请至少添加一条优惠信息'));
      } else {
        var invalid = value.find(function (item) {
          return item.fuCardId === null || item.fuCardId === undefined || item.fuCardId === '' || item.discountValue === null || item.discountValue === undefined;
        });
        if (invalid) {
          callback(new Error('每条优惠信息必须填写支付方式和折扣值'));
        } else {
          var invalidDiscount = value.find(function (item) {
            return item.discountValue <= 0 || item.discountValue >= 10;
          });
          if (invalidDiscount) {
            callback(new Error('折扣值必须大于0且小于10'));
          } else {
            callback();
          }
        }
      }
    };
    return {
      visible: false,
      loading: false,
      isEdit: false,
      formData: this.getDefaultForm(),
      rules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '活动名称长度在 1 到 100 个字符',
          trigger: 'blur'
        }],
        marketer: [{
          required: true,
          message: '请选择营销方',
          trigger: 'change'
        }],
        activityType: [{
          required: true,
          message: '请选择活动类型',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: '请选择活动状态',
          trigger: 'change'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }, {
          validator: validateTimeRange,
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }, {
          validator: validateTimeRange,
          trigger: 'change'
        }],
        customerId: [{
          required: true,
          message: '请选择适用小程序',
          trigger: 'change'
        }],
        supplierId: [{
          required: true,
          message: '请选择核销供应商',
          trigger: 'change'
        }],
        threshold: [{
          required: true,
          validator: validateThreshold,
          trigger: 'blur'
        }],
        thresholdCalcType: [{
          required: true,
          message: '请选择门槛计算方式',
          trigger: 'change'
        }],
        discountCalcType: [{
          required: true,
          message: '请选择优惠计算方式',
          trigger: 'change'
        }],
        showDiscountToMiniapp: [{
          required: true,
          message: '请选择核销商家小程序是否展示优惠',
          trigger: 'change'
        }],
        discountList: [{
          required: true,
          validator: validateDiscountList,
          trigger: 'blur'
        }]
      },
      customerList: [],
      customerLoading: false,
      supplierList: [],
      supplierLoading: false,
      paymentOptions: [{
        id: -1,
        name: '微信支付'
      }],
      // 微信=-1，福卡id从接口获取
      paymentLoading: false,
      couponList: [],
      couponLoading: false,
      storeList: [],
      storeLoading: false,
      storeParticipateType: 1
    };
  },
  methods: {
    getDefaultForm: function getDefaultForm() {
      return {
        id: null,
        activityCode: '',
        activityName: '',
        marketer: 1,
        activityType: 1,
        activityScene: 1,
        status: 1,
        startTime: null,
        endTime: null,
        customerId: null,
        supplierId: null,
        storeIds: null,
        description: '',
        threshold: 0,
        thresholdCalcType: 1,
        discountCalcType: 1,
        stackCalcType: 1,
        refundType: 1,
        shareType: 1,
        showDiscountToMiniapp: 1,
        remark: '',
        discountList: [{
          fuCardId: -1,
          discountValue: null
        }],
        couponIds: []
      };
    },
    openInit: function openInit() {
      var _this2 = this;
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.isEdit = !!row.id;
      if (row.id) {
        this.loadDetail(row.id);
      } else {
        this.formData = this.getDefaultForm();
        if (row.supplierId) {
          this.formData.supplierId = row.supplierId;
        }
        this.visible = true;
        this.$nextTick(function () {
          _this2.$refs.formRef && _this2.$refs.formRef.clearValidate();
          _this2.loadCustomerList();
          _this2.loadSupplierList();
        });
      }
    },
    loadDetail: function loadDetail(id) {
      var _this3 = this;
      instantDiscountApi.instantDiscountInfo(id).then(function (res) {
        var paymentList = res.paymentList && res.paymentList.length > 0 ? res.paymentList.map(function (item) {
          return {
            fuCardId: item.fuCardId !== undefined && item.fuCardId !== null ? item.fuCardId : null,
            discountValue: item.discountValue !== undefined && item.discountValue !== null ? item.discountValue : null
          };
        }) : [{
          fuCardId: -1,
          discountValue: null
        }];
        _this3.formData = _objectSpread(_objectSpread(_objectSpread({}, _this3.getDefaultForm()), res), {}, {
          discountList: paymentList,
          couponIds: res.couponIds || []
        });
        // 处理适用门店
        if (res.storeIds && res.storeIds.length > 0) {
          // storeIds 可能是逗号分隔的字符串或数组
          var storeIdArr = typeof res.storeIds === 'string' ? res.storeIds.split(',').map(function (id) {
            return parseInt(id.trim());
          }).filter(function (id) {
            return !isNaN(id);
          }) : res.storeIds;
          _this3.formData.storeIds = storeIdArr;
          _this3.storeParticipateType = 2;
          _this3.loadStoreList(res.supplierId);
        } else {
          _this3.storeParticipateType = 1;
          _this3.formData.storeIds = null;
        }
        _this3.visible = true;
        _this3.$nextTick(function () {
          _this3.$refs.formRef && _this3.$refs.formRef.clearValidate();
          _this3.loadCustomerList();
          _this3.loadSupplierList();
        });
      });
    },
    loadCustomerList: function loadCustomerList() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.customerLoading = true;
      instantDiscountApi.getMiniappList(keyword).then(function (res) {
        _this4.customerList = res || [];
        _this4.customerLoading = false;
      }).catch(function () {
        _this4.customerLoading = false;
        _this4.$message.error('获取小程序列表失败');
      });
    },
    loadSupplierList: function loadSupplierList() {
      var _this5 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierLoading = true;
      instantDiscountApi.supplierList(keyword).then(function (res) {
        _this5.supplierList = res || [];
        _this5.supplierLoading = false;
      }).catch(function () {
        _this5.supplierLoading = false;
        _this5.$message.error('获取核销供应商列表失败');
      });
    },
    handleSupplierChange: function handleSupplierChange(supplierId) {
      if (supplierId) {
        this.loadStoreList(supplierId);
      } else {
        this.storeList = [];
        this.formData.storeIds = null;
        this.storeParticipateType = 1;
      }
    },
    handleSupplierClear: function handleSupplierClear() {
      this.formData.supplierId = null;
      this.storeList = [];
      this.formData.storeIds = null;
      this.storeParticipateType = 1;
    },
    handleStoreParticipateTypeChange: function handleStoreParticipateTypeChange(type) {
      if (type === 1) {
        this.formData.storeIds = null;
      } else if (type === 2 && this.formData.supplierId) {
        this.loadStoreList(this.formData.supplierId);
      }
    },
    loadStoreList: function loadStoreList(supplierId) {
      var _this6 = this;
      if (!supplierId) return;
      this.storeLoading = true;
      instantDiscountApi.getStoreListBySupplierId(supplierId).then(function (res) {
        // 适配 autoList 返回的 {key, value} 格式，转换为 {id, name}
        _this6.storeList = (res || []).map(function (item) {
          return {
            id: item.key,
            name: item.value
          };
        });
        _this6.storeLoading = false;
      }).catch(function () {
        _this6.storeLoading = false;
        _this6.storeList = [];
        _this6.$message.error('获取门店列表失败');
      });
    },
    selectAllStores: function selectAllStores() {
      this.formData.storeIds = this.storeList.map(function (item) {
        return item.id;
      });
    },
    clearAllStores: function clearAllStores() {
      this.formData.storeIds = [];
    },
    loadPaymentOptions: function loadPaymentOptions() {
      var _this7 = this;
      // 加载福卡列表，微信支付固定为id=-1
      instantDiscountApi.getFucardList('').then(function (res) {
        var fukaList = (res || []).map(function (item) {
          return {
            id: item.id,
            name: item.card_name || item.name || item.cardName || item.title || '福卡'
          };
        });
        _this7.paymentOptions = [{
          id: -1,
          name: '微信支付'
        }].concat(_toConsumableArray(fukaList));
      }).catch(function () {
        _this7.$message.error('获取支付方式列表失败');
      });
    },
    getAvailablePayments: function getAvailablePayments(index) {
      // 过滤掉当前表格中其他行已选过的支付方式
      var selected = this.formData.discountList.map(function (item, idx) {
        return idx !== index ? item.fuCardId : null;
      }).filter(function (v) {
        return v !== null && v !== undefined && v !== '';
      });
      return this.paymentOptions.filter(function (p) {
        return !selected.includes(p.id);
      });
    },
    handlePaymentChange: function handlePaymentChange(val, index) {
      // 切换支付方式：若被其他行选中过，清空提示
      var dupIndex = this.formData.discountList.findIndex(function (item, idx) {
        return idx !== index && item.fuCardId === val;
      });
      if (dupIndex !== -1) {
        this.$message.warning('该支付方式已被其他优惠信息使用');
        this.formData.discountList[index].fuCardId = null;
      }
    },
    handleAddDiscount: function handleAddDiscount() {
      if (this.formData.discountList.length >= 10) {
        this.$message.warning('优惠信息最多10条');
        return;
      }
      // 默认选中当前未使用的第一个支付方式
      var available = this.getAvailablePayments(this.formData.discountList.length);
      var defaultFuCardId = available.length > 0 ? available[0].id : null;
      this.formData.discountList.push({
        fuCardId: defaultFuCardId,
        discountValue: null
      });
    },
    handleRemoveDiscount: function handleRemoveDiscount(index) {
      if (this.formData.discountList.length <= 1) {
        this.$message.warning('至少保留一条优惠信息');
        return;
      }
      this.formData.discountList.splice(index, 1);
    },
    searchCouponList: function searchCouponList(query) {
      var _this8 = this;
      this.couponLoading = true;
      instantDiscountApi.getCouponList(query).then(function (res) {
        var list = Array.isArray(res) ? res : (res === null || res === void 0 ? void 0 : res.list) || [];
        _this8.couponList = list.map(function (item) {
          return {
            id: item.id,
            name: item.name
          };
        });
        _this8.couponLoading = false;
      }).catch(function () {
        _this8.couponLoading = false;
        _this8.$message.error('获取优惠券列表失败');
      });
    },
    handleSubmit: (0, _validate.Debounce)(function () {
      var _this9 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;

        // 部分参与时必须选择至少一个门店
        if (_this9.storeParticipateType === 2 && (!_this9.formData.storeIds || _this9.formData.storeIds.length === 0)) {
          _this9.$message.warning('请选择参与门店');
          return;
        }

        // 如果部分参与且选择了全部门店，提示切换到全部参与
        /*
        if (this.storeParticipateType === 2 &&
        	this.formData.storeIds &&
        	this.storeList.length > 0 &&
        	this.formData.storeIds.length === this.storeList.length) {
        	this.$message.warning('已选择全部门店，请切换为「全部参与」');
        	return;
        }
        */

        _this9.loading = true;

        // 优惠信息表提交给后端
        var paymentList = _this9.formData.discountList.map(function (item, idx) {
          return {
            fuCardId: item.fuCardId,
            discountValue: item.discountValue,
            sort: idx
          };
        });

        // 构建提交数据
        var submitData = _objectSpread(_objectSpread({}, _this9.formData), {}, {
          paymentList: paymentList
        });

        // 仅当选择了部分参与且选择了具体门店时才传递 storeIds
        if (_this9.storeParticipateType === 2 && _this9.formData.storeIds && _this9.formData.storeIds.length > 0) {
          submitData.storeIds = _this9.formData.storeIds.join(',');
        } else {
          // 全部参与时，不传递 storeIds 字段
          delete submitData.storeIds;
        }
        var apiMethod = _this9.isEdit ? instantDiscountApi.instantDiscountUpdate : instantDiscountApi.instantDiscountSave;
        apiMethod(submitData).then(function () {
          _this9.$message.success('操作成功');
          _this9.loading = false;
          _this9.visible = false;
          _this9.$emit('doRefresh');
        }).catch(function () {
          _this9.loading = false;
        });
      });
    }),
    handleClose: function handleClose() {
      this.visible = false;
    },
    handleDialogClose: function handleDialogClose() {
      this.formData = this.getDefaultForm();
      this.storeList = [];
      this.storeParticipateType = 1;
      this.$refs.formRef && this.$refs.formRef.clearValidate();
    }
  },
  mounted: function mounted() {
    // 初始化加载支付方式列表
    this.loadPaymentOptions();
    // 默认拉取可叠加优惠券列表（不输入关键词也能看到可选券）
    this.searchCouponList('');
  }
};